// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'https://localhost:9002',
  // USJ:
  // baseUrl: 'https://api.cjd9nvicvo-comcastca1-s1-public.model-t.cc.commerce.ondemand.com/',
  // baseUrl: 'https://api.cjd9nvicvo-comcastca1-d1-public.model-t.cc.commerce.ondemand.com',
    //  baseUrl: 'https://api.cjd9nvicvo-comcastca1-d3-public.model-t.cc.commerce.ondemand.com',
  // UDX:
  // baseUrl: 'https://api.c4a4eqevr0-universal1-s1-public.model-t.cc.commerce.ondemand.com',
  baseUrl: 'https://api.c4a4eqevr0-universal1-d5-public.model-t.cc.commerce.ondemand.com/',
  adobeScript: 'https://assets.adobedtm.com/a2ef59fba8e9/665180b57410/launch-8745023a9621-development.min.js',
  prefix: '/occ/v2/',
  smartedit: {
    allowedOrigin: 'localhost:9002, backoffice.c4a4eqevr0-universal1-d1-public.model-t.cc.commerce.ondemand.com:443, backoffice.c4a4eqevr0-universal1-d2-public.model-t.cc.commerce.ondemand.com:443, backoffice.c4a4eqevr0-universal1-d3-public.model-t.cc.commerce.ondemand.com:443,backoffice.c4a4eqevr0-universal1-s1-public.model-t.cc.commerce.ondemand.com:443, backoffice.c4a4eqevr0-universal1-d4-public.model-t.cc.commerce.ondemand.com:443, backoffice.c4a4eqevr0-universal1-d5-public.model-t.cc.commerce.ondemand.com:443, backoffice.c4a4eqevr0-universal1-p1-public.model-t.cc.commerce.ondemand.com:443, *.universaldestinationsandexperiences.com:443, *.universaldestinationsandexperiences.com:80, *.model-t.cc.commerce.ondemand.com:443, *.model-t.cc.commerce.ondemand.com:80',
  },
  client_id_value_prod_NA: 'mBl8RbG6tUU3XYn6PaYssg6Da8vrdPJJW67P4zH9klvXYTiQ8E',
  client_id_value_prod_JA: 'Tjx8945rhMyQfHoi',
  client_id_value_non_prod: 'secret',

  cmp: {

    d1: {
      url: 'https://usj-api-dev.use.ucdp.net/oidc/connect/authorize?',
      redirect_uri:
        'https://b2bportal-dev.usj.co.jp/cmp/en/JPY/cmp-success',
      wts_redirect_uri: 'https://usj-shop-dev.use.ucdp.net/spa_redirect',
      client_id: 'c24d8b53-c3c1-4ccb-8537-9067e9205451',
      client_id_value: 'igrQf3noyEAWvEq4m9L32vRkRtPj8efJvy9QGnsBbK6bOkb60J',
    },
    d5: {
      url: 'https://api-uat.usj.co.jp/oidc/connect/authorize?',
      redirect_uri:
        'https://b2bportal-uat.usj.co.jp/cmp/en/JPY/cmp-success',
      wts_redirect_uri: 'https://shop-uat.usj.co.jp/spa_redirect',
      client_id: 'a27e4921-8e2c-46f3-9a21-d8849278ae45',
      client_id_value: 'fhfdFSDf356hWrttmWongui033rWgbHkwegoOpPPgsm423Dss',
    },
    d3: {
      url: 'https://usj-api-qa.use.ucdp.net/oidc/connect/authorize?',
      redirect_uri:
        'https://b2bportal-qa.usj.co.jp/cmp/en/JPY/cmp-success',
      wts_redirect_uri: 'https://usj-shop-qa.use.ucdp.net/spa_redirect',
      client_id: '413324d9-4e34-49f0-9a58-f561f966325e',
      client_id_value: 'guMRBXbhSQa8cLXFEMYcKRxm23IjDwQ1hLHorTVGsHOtXtKGKU',
    },
    s1: {
      url: 'https://api-stg.usj.co.jp/oidc/connect/authorize?',
      redirect_uri:
        'https://b2bportal-stg.usj.co.jp/cmp/en/JPY/cmp-success',
      wts_redirect_uri: 'https://shop-stg.usj.co.jp/spa_redirect',
      client_id: 'bf35ef93-9a0a-4aab-885a-c3a5e1a56710',
      client_id_value: 'rTMdMbZ5vKwDsUsgR3sMdwwV2RDdGHk3p3HIp6KdXIblUmGY3T',
    },
    p1: {
      url: 'https://api.usj.co.jp/oidc/connect/authorize?',
      redirect_uri:
        'https://b2bportal.usj.co.jp/cmp/en/JPY/cmp-success',
      wts_redirect_uri: 'https://store.usj.co.jp/spa_redirect',
      client_id: 'f4f46976-1812-480b-8509-7fca2b9172d7',
      client_id_value: 'HVq9HAIaRV8UG8ruynS70MT83dEpWDUlixX0PKD6ioKqlxdzvi',
    },
    grant_type: 'authorization_code',
    response_type: 'code id_token token',
    scope: 'openid default offline_access',
  },

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
